import { isEmpty, noop } from 'lodash';

import { FeaturedTagItem, FilterState } from '@/components/FilterManager/types';

import TagFilterContainer from '../NestedFilter/NestedFilterPill/tagFilters/TagFilter';
import { useTagStateAndMethods } from '../NestedFilter/NestedFilterPill/tagFilters/useTagStateAndMethods';

export default function FeaturedTagFilters({
  item,
  filter,
  setFilter,
}: {
  filter: FilterState;
  setFilter: (filter: any) => void;
  item: FeaturedTagItem;
}) {
  const filterKey = 'featuredTagFilters';
  const {
    methods,
    state: { selectedFilters },
  } = useTagStateAndMethods({
    filter,
    setFilter,
    id: filterKey,
  });

  return (
    <>
      {item.queryParams?.tagIds?.map((elm: any) => {
        let selectedFilter: any[] = selectedFilters as any[];
        let tag = Array.isArray(selectedFilters)
          ? selectedFilter?.filter((tag) => tag.tagId === elm)[0]
          : { tagId: elm };
        if (isEmpty(tag)) {
          tag = { tagId: elm };
        }

        return (
          <TagFilterContainer
            key={tag.tagId + tag.type}
            setFilterIdToOpen={noop}
            tagFilterType={tag}
            onTagTypeFilterChange={methods.onTagTypeFilterChange}
          />
        );
      })}
    </>
  );
}
